export const environment = {
  production: true,
  finalVersion: true,
  apiLink: "https://teamplus.gamehill.pl/api/public",
  
  smartChat: false,
  ggAnalitics: false,
  snow: false,

  pageTitle: "Teamplus",
  
  // A - logowanie z prostą rejestracją na mail z bazy
  // B - logowanie z podziałem na 2 role z formularzem rejestracyjnym
  loginVariant: "A",
  counterVariant: "C",

  googleKey: "767855197817-spfuBndh4a5.apps.googleusercontent.com",
  client_id: '1_BuuNIwDHSxxUAx7aDqQKfGFNu0G92',
  client_secret : 'RIfGBqlq5riHOF7jJAmlLdpFtoTGiKiVxnrJ9wWZkGvTaXf8y',
  fbKey : '2342346332277',
  staticTocken : 'NDRhM2NlNTczZTgwZGNhOTFiZTI3OHDYTGH7BHTGzZjI4Y2QzMzBkNndeuhfjBBoyNGRkNWFhOGVjNA',
  googleAnalitics : "",

  // moduły aplikacji dostępne przez nawigację
  kalendarzModule: false,
  rankingModule: true,
  nagrodyModule: true,
  skrzynkaModule: true,
  kontaktModule: true,
  regulaminModule: true,
  szefModule: true,
  spolecznoscModule: false,
  osiagnieciaModule: false,
  szkoleniaModule: false,
  cytatyModule: false,
  profilModule: true,
  leagueModule: false,
  zapisySzkoleniaModule: true,
  
  navModule: [
    {myID:'mapaModule', name:"NAV.Mapa", link:"/app/game/mapa", icoClass:"mapaIco"},
    {myID:'rankingModule', name:"NAV.Ranking", link:"/app/game/ranking", icoClass:"rankingIco"},
    {myID:'nagrodyModule', name:"NAV.Nagrody", link:"/app/game/prize", icoClass:"sklepIco"},
    {myID:'skrzynkaModule', name:"NAV.Skrzynka", link:"/app/game/news", icoClass:"newsIco"},
    {myID:'zapisySzkoleniaModule', name:"NAV.Coaching", link:"/app/game/szkolenia-zapisy", icoClass:"szefIco"},
    {myID:'kontaktModule', name:"NAV.Kontakt", link:"/app/game/contact", icoClass:"kontaktIco"},
    {myID:'szefModule', name:"NAV.Panel_szefa", link:"/app/game/boss", icoClass:"szefIco"}
],


  rankingDefaultPage: "ogolny",
  rankingSeasonsEnabled: false,
  rankingGeneralEnabled: true,
  rankingUsersEnabled: false,
  rankingAjentsEnabled: false,
  rankingTeamsEnabled: true,
  rankingMyTeanEnabled: true,
  rankingRksEnabled: true,
  rankingActivitiesEnabled: true,
  rankingShowPsdNumber: true,
  rankingShowCoins: false,

  yourPonitsCounter: true,
  yourProgressCounter: true,
  yourCoinsCounter: true,
  inGameCounter: true,
  newTasksCounter: true,
  teamProgressCounter: false,
  
  loginBackgroundCount: 0, // 0 nie używaj, 1-oo używaj (gdzie watość to ilość grafik + 1 )
  acivitesMapWidget: true,
  scrollForAcivitesWidget: false,
  ranking_liczbaZadanwCalejGrze: 123,
  
  chapters: [ // nie zapomnieć policzyć też sekcji domyślenj (POLSKA, HISZPANIA, itp)
    {name:"Francja", sections:3},
    {name:"WŁOCHY", sections:3},
    {name:"ROSJA", sections:3},
    {name:"CHORWACJA", sections:4},
    {name:"HISZPANIA", sections:3},
    {name:"CZECHY", sections:3},
    {name:"SZWAJCARIA", sections:3},
  ],

  assetsFolder: "alior",
  mapVersion: "A", // A - stara wersja Europa, B - Europa z Rosją
  profilEdit: false
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts